export const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT;
export const APP_BASE_URL = process.env.REACT_APP_BASE_URL;

export const IDP_ENDPOINT = process.env.REACT_APP_IDP_ENDPOINT;

export const EVERY_CLIENT_ID = process.env.REACT_APP_EVERY_CLIENT_ID;
export const EVERY_CLIENT_SECRET = process.env.REACT_APP_EVERY_CLIENT_SECRET;
export const EVERY_AUTH_PROXY_SERVER_URL =
  process.env.REACT_APP_EVERY_AUTH_PROXY_SERVER_URL;
export const EVERY_REDIRECT = process.env.REACT_APP_EVERY_REDIRECT;

export const LINE_CLIENT_ID = process.env.REACT_APP_LINE_CLIENT_ID;
export const LINE_CLIENT_SECRET = process.env.REACT_APP_LINE_CLIENT_SECRET;
export const LINE_AUTH_PROXY_SERVER_URL =
  process.env.REACT_APP_LINE_AUTH_PROXY_SERVER_URL;
export const LINE_REDIRECT = process.env.REACT_APP_LINE_REDIRECT;

export const CHARGE_URL = process.env.REACT_APP_CHARGE_URL;

export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
export const FIREBASE_AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
export const FIREBASE_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID;
export const FIREBASE_STORAGE_BUCKET =
  process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
export const FIREBASE_MESSAGE_SENDER_ID =
  process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID;
export const FIREBASE_APP_ID = process.env.REACT_APP_FIREBASE_APP_ID;
export const FIREBASE_MEASUREMENT_ID =
  process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;

export const REPRO_SDK_TOKEN = process.env.REACT_APP_REPRO_SDK_TOKEN;

export const AGORA_APP_ID = process.env.REACT_APP_AGORA_APP_ID as string;
